import { inventoryModal } from '~/store/States/inventory';
import { useConfigMC, useData } from '~/store/Query/api';

export default function InventoryNotify({ showAviso = true, space = true }) {
  const config = useData(useConfigMC);

  if (!config) {
    return null;
  }

  const { texto, colorBoton } = config.inventario;

  return (
    <div className="no-availability">
      {showAviso && <p className="stock-aviso" dangerouslySetInnerHTML={{ __html: texto.aviso }} />}
      <div className={`format-caption message-movil not-stock ${space ? 'space' : ''}`}>
        <span dangerouslySetInnerHTML={{ __html: texto.mensaje }} />
        <button
          type="button"
          className="red-claro-btn"
          style={{ '--no-stock-button': colorBoton }}
          onClick={() => inventoryModal.set(true)}
        >
          <i className="far fa-bell"></i>
          <span dangerouslySetInnerHTML={{ __html: texto.boton }} />
        </button>
      </div>
    </div>
  );
}
